import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product_detail_area"
}
const _hoisted_2 = { class: "thum_img_bx" }
const _hoisted_3 = { class: "guide_item_bx" }
const _hoisted_4 = /*#__PURE__*/_createVNode("dt", { class: "blind" }, "상품명", -1)
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/_createVNode("dt", { class: "blind" }, "상품설명", -1)
const _hoisted_7 = { class: "description" }
const _hoisted_8 = /*#__PURE__*/_createVNode("dt", { class: "blind" }, "정가", -1)
const _hoisted_9 = { class: "price original" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "원", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("dt", { class: "blind" }, "할인율", -1)
const _hoisted_12 = { class: "price dc_ratio" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "%", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("dt", { class: "blind" }, "할인가", -1)
const _hoisted_15 = { class: "price sale" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "원", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.product)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _ctx.product.productImageUrl,
            class: "thum_img",
            alt: ""
          }, null, 8, ["src"])
        ]),
        _createVNode("dl", _hoisted_3, [
          _hoisted_4,
          _createVNode("dd", _hoisted_5, _toDisplayString(_ctx.product.productName), 1),
          _hoisted_6,
          _createVNode("dd", _hoisted_7, _toDisplayString(_ctx.product.productIntroText), 1),
          (_ctx.product.discountInfoIsExposable)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_8,
                _createVNode("dd", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.product.commaListPrice), 1),
                  _hoisted_10
                ]),
                _hoisted_11,
                _createVNode("dd", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.product.discountRate), 1),
                  _hoisted_13
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_14,
          _createVNode("dd", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.product.commaSalePrice), 1),
            _hoisted_16
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}